import React, { useEffect } from 'react';
import '../../css/levels.css';
import Level from './Level';
import { CARDS_PER_LEVEL } from '../../constants';

function Levels(props) {

  let { number,
    allLevelStatus,
    selectedLevel
  } = props;


  let levelAmount = Math.ceil(number.count / CARDS_PER_LEVEL);
  // console.log(levelAmount)

  let numberOfLevelsArray = [];

  function makeArrayFromLevelAmount() {
    for (let i = 0; i < levelAmount; i++) {
      numberOfLevelsArray.push(i);
    }
    // console.log(numberOfLevelsArray)
  }

  makeArrayFromLevelAmount()

  useEffect(() => {
    const el = document.getElementById(`level_${selectedLevel}`);
    if (el) {
      el.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
    }
  }, [selectedLevel]);


  return (
    <>
      <div id="levels">
        {/* Levels */}
        {numberOfLevelsArray.map((level) => (
        <Level allLevelStatus={allLevelStatus} {...allLevelStatus} selectedLevel={selectedLevel} key={`levelLink_${level}`} level={level}/>
      ))}
      </div>
    </>
  )
}

export default Levels;
